//REGISTER
export const POST_FAKE_REGISTER = '/auth/signup';

//LOGIN
export const POST_FAKE_LOGIN = '/auth/signin';
export const POST_FAKE_JWT_LOGIN = '/post-jwt-login';
export const POST_FAKE_PASSWORD_FORGET = '/auth/forgot-password';
export const POST_FAKE_JWT_PASSWORD_FORGET = '/jwt-forget-pwd';

export const POST_JWT_PASSWORD_FORGET = '/user/reset-password/request';
export const POST_JWT_PASSWORD_RESET = '/user/reset-password/set-new';

//PROFILE
export const POST_EDIT_JWT_PROFILE = '/post-jwt-profile';
export const POST_EDIT_PROFILE = '/user';

// Dashboard Ecommerce
// Revenue
export const GET_ALLREVENUE_DATA = '/allRevenue-data';
export const GET_MONTHREVENUE_DATA = '/monthRevenue-data';
export const GET_HALFYEARREVENUE_DATA = '/halfYearRevenue-data';
export const GET_YEARREVENUE_DATA = '/yearRevenue-data';

//JOB API Key
export const GET_API_KEY = '/api-key';

// AUTH
export const POST_LOGIN = '/token';
export const POST_AZURE_LOGIN = '/azure/token';
export const GET_PROFILE = '/users/me';

// USER
export const USER = '/user';
export const GET_USERS = '/user/';
export const DELETE_USER = '/user';
export const ADD_USER = '/user/';
export const UPDATE_USER = '/user';
export const PRIVACY_POLICY_USER = '/user/privacy_policy';
export const PASSWORD_USER = '/user/password';
export const INFO_USER = '/user/info';
export const ESTABLISHMENT_USER = '/user/establishment';

// ROLES
export const GET_ROLES = '/permissions/roles';
export const GET_ROLE = '/permissions/roles/';
export const ADD_ROLE = '/permissions/roles/';
export const UPDATE_ROLE = '/permissions/roles/';
export const DELETE_ROLE = '/permissions/roles/';

// Menu Scopes
export const GET_MENU_SCOPES_ROLE = '/permissions/menu_scopes/role/';

// SCOPES
export const GET_SCOPES = '/permissions/scopes';
export const GET_SCOPE = '/permissions/scopes/';
export const ADD_SCOPE = '/permissions/scopes/';
export const UPDATE_SCOPE = '/permissions/scopes/';
export const DELETE_SCOPE = '/permissions/scopes/';

// Establishment Assignation
export const ESTABLISHMENT_ASIGNATION = '/establishment_asignation';
export const GET_ESTABLISHMENT_ASIGNATIONS = '/establishment_asignation/';
export const DELETE_ESTABLISHMENT_ASIGNATION = '/establishment_asignation';
export const ADD_ESTABLISHMENT_ASIGNATION = '/establishment_asignation/';
export const UPDATE_ESTABLISHMENT_ASIGNATION = '/establishment_asignation';



export const GET_USER_BY_ROLES = '/permissions/users';
